// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: rgb(6, 93, 151);
}

.cart_page{
  max-width: 1000px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.cart{
  display: flex;
  margin: 30px auto;
  height: max-content;
  padding: 20px 20px 0 20px;
  gap: 20px;
  flex: 1 1;
}

.cart_list{
  padding: 20px;
  width: 100%;
  background-color: rgb(200, 255, 255);
  border-radius: .5em;
}

.cart_list h3{
  font-size: 1em;
  font-weight: 450;
  padding-bottom: 20px;
  border-bottom: 1px solid gainsboro;
}

.placebutton {
  margin: 1em;
  font-weight: bold;
  font-size: 1.5em;
  padding: .75em;
  border-radius: .5em;
  color: rgb(8, 70, 19);
  border: none;
}

.linkbutton {
  margin: 1em;
text-decoration: none;
padding: .5em;
border-radius: .5em;
background-color: rgb(255, 255, 255);
color: black;
border: none;
}

.placebutton:hover,.linkbutton:hover {
  background-color: #98c2f0;
}`, "",{"version":3,"sources":["webpack://./src/pages/cart.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,aAAa;EACb,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;AACb,qBAAqB;AACrB,aAAa;AACb,mBAAmB;AACnB,oCAAoC;AACpC,YAAY;AACZ,YAAY;AACZ;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["body {\n  background-color: rgb(6, 93, 151);\n}\n\n.cart_page{\n  max-width: 1000px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n}\n\n.cart{\n  display: flex;\n  margin: 30px auto;\n  height: max-content;\n  padding: 20px 20px 0 20px;\n  gap: 20px;\n  flex: 1;\n}\n\n.cart_list{\n  padding: 20px;\n  width: 100%;\n  background-color: rgb(200, 255, 255);\n  border-radius: .5em;\n}\n\n.cart_list h3{\n  font-size: 1em;\n  font-weight: 450;\n  padding-bottom: 20px;\n  border-bottom: 1px solid gainsboro;\n}\n\n.placebutton {\n  margin: 1em;\n  font-weight: bold;\n  font-size: 1.5em;\n  padding: .75em;\n  border-radius: .5em;\n  color: rgb(8, 70, 19);\n  border: none;\n}\n\n.linkbutton {\n  margin: 1em;\ntext-decoration: none;\npadding: .5em;\nborder-radius: .5em;\nbackground-color: rgb(255, 255, 255);\ncolor: black;\nborder: none;\n}\n\n.placebutton:hover,.linkbutton:hover {\n  background-color: #98c2f0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
